import InsertChartIcon from './InsertChart';
export default InsertChartIcon;
